import React, { createContext, useContext, useState, useEffect } from 'react';

// Fully separate from AuthContext (staff) and CreatorAuthContext (creator) —
// different cookie (brand_token), different endpoints, different principal
// shape. Must never be merged with either so the three session worlds can't
// cross-contaminate on the shared creators.socialinfinite.com origin.
const BrandAuthContext = createContext(null);

export function BrandAuthProvider({ children }) {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/brand-auth/me', { credentials: 'include' })
      .then(r => r.json())
      .then(d => { if (d.success) setContact(d.contact); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  async function requestOtp(email) {
    const res = await fetch('/api/brand-auth/request-otp', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    if (!res.ok) return { success: false, error: data.error || 'Something went wrong.' };
    return { success: true };
  }

  async function verifyOtp(email, code) {
    const res = await fetch('/api/brand-auth/verify-otp', {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, code }),
    });
    const data = await res.json();
    if (!res.ok) return { success: false, error: data.error || 'Invalid or expired code.' };
    setContact(data.contact);
    return { success: true };
  }

  async function logout() {
    await fetch('/api/brand-auth/logout', { method: 'POST', credentials: 'include' });
    setContact(null);
  }

  return (
    <BrandAuthContext.Provider value={{ contact, loading, requestOtp, verifyOtp, logout }}>
      {children}
    </BrandAuthContext.Provider>
  );
}

export function useBrandAuth() {
  return useContext(BrandAuthContext);
}
